import "./platform/tracing/web-tracing"; // Must be first import — OTel instrumentation

import React from "react";

import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";
import { eventBus } from "./platform/events/EventBus";
import { ServiceRegistry } from "./platform/services/ServiceRegistry";
import { GateManager } from "./platform/state/GateManager";
import { reportWebVitals } from "./platform/utils/webVitals";

// Initialize service registry and gate manager
// Pass eventBus to ServiceRegistry for progress tracking
const serviceRegistry = new ServiceRegistry(eventBus);
const gateManager = new GateManager();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App serviceRegistry={serviceRegistry} gateManager={gateManager} />
  </React.StrictMode>,
);

// Start collecting Core Web Vitals (LCP, INP, CLS, FCP, TTFB)
reportWebVitals();
